<template>
  <div
    class="app-main"
    style="padding-left: 2em; padding-right: 2em; width: 100%;"
  >
    <router-view
      v-slot="{ Component }"
      :key="route.fullPath"
    >
      <keep-alive :include="[]">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script lang="ts">
//import { defineComponent, computed } from 'vue'
import { defineComponent} from 'vue'
//import { useRoute, useRouter } from 'vue-router'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'AppMain',
  props: {
    // transitionName: {
    //   type: String,
    //   default: 'el-fade-in',
    // },
  },
  setup () {
    // const { route, store } = useEnhancer()
    // const cachedViews = computed(() => store.getters.cachedViews)
    const route = useRoute()
    return {
      route,
      //cachedViews,
    }
  },
})
</script>

<style scoped>

</style>